export default {

    SAVE_JOB: undefined,
    SAVE_JOB_SUCCESS: undefined,
    SAVE_JOB_FAILURE: undefined,

    GET_JOB: undefined,
    GET_JOB_SUCCESS: undefined,
    GET_JOB_FAILURE: undefined,

    EXECUTE_JOB: undefined,
    EXECUTE_JOB_SUCCESS: undefined,
    EXECUTE_JOB_FAILURE: undefined,

    CLEAR_REDUX_DATA_OF_COMPONENT_IN_JOB_STORE: undefined
}